<template>
  <div>
    <h4>History</h4>

    <template v-for="day_data in task_list_data.days">

      <h5 v-bind:key="day_data.day">{{day_data.day_formatted}}</h5>
      <table class="table-bordered align_left tasks_table" v-bind:key="day_data.day">
        <thead>
        <tr>
        </tr>
        </thead>
        <tbody class="align_left todo_background">

          <tr v-for="record in day_data.data" v-bind:key="record.id">

            <template v-if="record.record_type === 1">

              <template v-if="record.same_counter > 1">
                <td :rowspan="record.same_counter" class="salesperson_field shop_background td_field">
                  {{record.sales_person_name}}
                </td>
                <td :rowspan="record.same_counter" class="shop_field shop_background td_field">
                  {{record.customer_company_name}} - {{record.customer_id}}
                </td>
              </template>
              <template v-if="record.same_counter === 1">
                <td  class="salesperson_field shop_background td_field">
                  {{record.sales_person_name}}
                </td>
                <td class="shop_field shop_background td_field">
                  {{record.customer_company_name}} - {{record.customer_id}}
                </td>
              </template>

  <!--            <td class="">-->
  <!--              {{record.same_counter}}-->
  <!--            </td>-->

              <td class="notes_background td_field td_notes_field">
                <div v-for="(note_line,line_index) in record.notes_array" v-bind:key="line_index">
                  {{note_line}}
                </div>
              </td>
              <td class="todo_background td_field">
                <div v-for="(todo_line,line_index) in record.todo_text_array" v-bind:key="line_index">
                  {{todo_line}}
                </div>
              </td>
              <td class="todo_background td_field todo_person_date_field">
                {{record.sales_person_name_todo}}
              </td>
              <td class="todo_background td_field todo_person_date_field">
                {{record.todo_date_formatted}}
              </td>
            </template>

            <template v-if="record.record_type === 2">
              <td class="td_field duty_background">
                {{record.duty_salesperson_name}}
              </td>
              <td class="td_field duty_background" :colspan="5">
                {{record.duty_text}}
              </td>
            </template>

          </tr>

        </tbody>
      </table>

    </template>
    <br>
    <br>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {

    }
  },
  computed: {
    ...mapGetters({
      task_list_data: 'admin/task_list_data',
    }),
    // person_day_is_set() {
    // },
  },
  watch: {
    // sales_tasks_details: async function () {
    // },
  },
  mounted() {
    this.get_task_history_list();
  },
  methods: {
    get_task_history_list() {
      this.$store.dispatch('admin/getTaskList', {'days_back': 30});
    }

  }
}
</script>

<style scoped>

.salesperson_field {
  width: 80px;
}

.shop_field {
  width: 240px;
}

.todo_person_date_field {
  width: 100px;
}

.td_notes_field {

}


.delete_duty_button {
  margin: 7px;
  font-size: 16px;
  color: black;
  background-color: lightcoral;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 3px;
  padding-bottom: 2px;
  border-radius: 5px;
  border-style: hidden;
  font-weight: 500;
}

.add_duty_button {
  margin: 7px;
  font-size: 16px;
  color: black;
  background-color: lightgreen;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 3px;
  padding-bottom: 2px;
  border-radius: 5px;
  border-style: hidden;
  font-weight: 500;
}

.add_duty_td {
  vertical-align: middle;
  text-align: center;
}

.find_shop_button {
  margin: 7px;
  font-size: 16px;
  color: black;
  background-color: lightskyblue;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 3px;
  padding-bottom: 2px;
  border-radius: 5px;
  border-style: hidden;
  font-weight: 500;
}

.add_shop_line_button {
  font-size: 16px;
  color: black;
  background-color: lightgreen;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 3px;
  padding-bottom: 2px;
  border-radius: 5px;
  border-style: hidden;
  font-weight: 500;
}

.align_left {
  text-align: left;
}

.duty_background {
  background-color: #ffe0e0;
}

.shop_background {
  background-color: #FFFFFF;
}

.notes_background {
  background-color: #f0f0ff;
}

.todo_background {
  background-color: #f0fff0;
}

.th_header {
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 5px;
  padding-bottom: 7px;
}

.td_dispensary {
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 5px;
  padding-bottom: 7px;

  font-weight: 700;
  width: 240px;
}

.tasks_table {
  margin: 10px;
  width:calc(100% - 22px);
}



.td_field {
  padding-left: 7px;
  margin: 7px;
}

.duty_notes {
  width: 100%;
}


.search_shop {
  vertical-align: middle;
  text-align: center;
  padding: 7px;
}


.find_shop_input {
  margin:7px;
  width: 126px;
}


</style>
